import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

export const GQL_IMPERSONATE = typedGql('mutation')({
  impersonateUser: [
    { userId: $('userId', 'String!') },
    {
      __typename: true,
      '...on UserInfo': {
        email: true,
        username: true,
        firstName: true,
        lastName: true,
        roles: true,
        id: true,
        impersonatorId: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_STOP_IMPERSONATE = typedGql('mutation')({
  stopImpersonate: {
    __typename: true,
    '...on UserInfo': {
      email: true,
      username: true,
      firstName: true,
      lastName: true,
      roles: true,
      id: true,
    },
    '...on CustomError': {
      error: true,
      message: true,
    },
  },
})

export const GQL_LOGIN = typedGql('mutation')({
  login: [
    { identifier: $('identifier', 'String!'), password: $('password', 'String!') },
    {
      __typename: true,
      '...on UserInfo': {
        firstName: true,
        lastName: true,
        roles: true,
        email: true,
        username: true,
        id: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_REQUEST_MAGIC_LINK = typedGql('mutation')({
  requestMagicLink: [{ email: $('email', 'String!') }, true],
})

export const GQL_LOGIN_MAGIC_LINK = typedGql('mutation')({
  loginWithMagicLink: [
    { token: $('token', 'String!') },
    {
      __typename: true,
      '...on UserInfo': {
        firstName: true,
        lastName: true,
        roles: true,
        email: true,
        id: true,
      },
      '...on CustomError': {
        error: true,
        message: true,
      },
    },
  ],
})

export const GQL_SEND_RESET_PASSWORD = typedGql('mutation')({
  askForResetPassword: [{ email: $('email', 'String!') }, true],
})

export const GQL_RESET_PASSWORD = typedGql('mutation')({
  resetPassword: [
    {
      email: $('email', 'String!'),
      password: $('password', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_REFRESH = typedGql('mutation')({
  refresh: {
    __typename: true,
    '...on UserInfo': {
      firstName: true,
      lastName: true,
      roles: true,
      email: true,
      username: true,
      id: true,
    },
    '...on CustomError': {
      error: true,
      message: true,
    },
  },
})

export const GQL_LOGOUT = typedGql('mutation')({
  logout: true,
})

/** Échange du jeton de passage SSO contre une session (#40). */
export const GQL_LOGIN_UNIQUE = typedGql('mutation')({
  uniqueAuthFromSso: [
    {
      token: $('token', 'String!'),
    },
    {
      access_token: true,
      firstName: true,
      lastName: true,
      role: true,
      email: true,
      id: true,
    },
  ],
})

// Identité déjà connue du serveur pour un lien d'invitation (#17) : l'écran
// d'activation la préremplit au lieu de la redemander.
export const GQL_INVITATION = typedGql('query')({
  invitation: [
    { token: $('token', 'String!') },
    {
      status: true,
      email: true,
      firstName: true,
      lastName: true,
    },
  ],
})

export const GQL_FINISH_REGISTER = typedGql('mutation')({
  finishRegister: [
    {
      password: $('password', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_VERIFY_ACCOUNT = typedGql('mutation')({
  verifyEmail: [
    {
      email: $('email', 'String!'),
      token: $('token', 'String!'),
    },
    true,
  ],
})

export const GQL_RESEND_EMAIL_VALIDATION = typedGql('mutation')({
  reSendEmailValidation: [
    {
      email: $('email', 'String!'),
    },
    true,
  ],
})

export const GQL_ME = typedGql('query')({
  me: {
    firstName: true,
    lastName: true,
    email: true,
    username: true,
    roles: true,
    id: true,
    impersonatorId: true,
    capabilities: true,
    orgSlug: true,
  },
})
